import { useMemo } from 'external/react'

import LanguageBar from './LanguageBar'
import Course from './Course'

import usePayment from 'context/payment-context/hook'
import usePublic from 'context/public-context/hook'

export default function Courses () {

    const {updateCart, cart } = usePayment()
    const {offerData: {courses: offerCourses = []}, params, query: {languageId, fromCart, extra}, navigation} = usePublic()

	const { idSubject, idSelectCourse, typeSubject } = params

    const courses = useMemo(() => {
        return offerCourses.filter(({subject, language}) => subject == idSubject && language === languageId)
    }, [offerCourses, languageId, idSubject]) 


    const courseSelected = useMemo(() => {
        const target = typeSubject === 'basic' ? cart.properties.basic : cart.properties.elective
        if (!target) return
        const index = target.findIndex(id => id && id.startsWith(idSubject))
        if (index != idSelectCourse) return
        return target[index]
    }, [cart.properties, idSubject, typeSubject])

    const extraCourseSelected = useMemo(() => {
        const target = typeSubject === 'basic' ? cart.properties.basicExtra : cart.properties.electiveExtra
        if (!target) return
        const index = target.findIndex(id => id && id.startsWith(idSubject))
        if (index != idSelectCourse) return
        return target[index]
    }, [cart.properties, idSubject, typeSubject, extra])

	async function handleSelectCourse (id, remove, extra) {
        const action = remove ? 'delete' : 'update'
        await updateCart(extra === 'true' ? `${typeSubject}Extra` : typeSubject, idSelectCourse, id, action)
        if (action == 'update') {
            if (fromCart) navigation.summary.go()
            else navigation.offer.go()
        }
	}
    const electivesInCart = useMemo(() => (cart.properties.elective || []).filter(c => c), [cart.properties])

	return (
		<div className='container_container'>
			<h2 className='title_subject'>Elija un curso para continuar.</h2>
			<div className='body_subject'>
                <LanguageBar />
				{courses.length > 0 && (
					<div className='bodyList_Course'>
						{courses.map((course, index) => {
                            return (
                                <Course
                                    key={index}
                                    id={course.id}
                                    electivesInCart = {electivesInCart}
                                    elective={course.subject === 'C7'}
                                    name={course.name}
                                    fromCart={fromCart}
                                    courseSelected={courseSelected}
                                    extra={extra}
                                    extraCourseSelected={extraCourseSelected}
                                    handleSelectCourse={handleSelectCourse}
                                />)
                        })}
					</div>
				)
            }
			</div>
		</div>
	)
}